import { Injectable } from '@angular/core';
import * as SockJS from 'sockjs-client';
import { environment } from 'src/environments/environment';
import * as Stomp from 'stompjs';
import { FreeFormAgendaService } from './free-form-agenda.service';
import { FreeFormMinutesService } from './free-form-minutes.service';
import { AgoraConfigService } from 'src/AgoraConfigService';
//import {Stomp} from '@stomp/stompjs';
// import * as SockJS from 'sockjs-client';
@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  webSocketEndPoint = `${environment.webSocketEndPoint}`;
  stompClient: any;
  topic!:String;
  audioStompClient:any;
  audiotopic!:String;
  
  meetings: string[] = [];
    agoraConfigObject: any;
  constructor(private commonAgService:FreeFormAgendaService,private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.webSocketEndPoint = this.agoraConfigObject.webSocketEndPoint;
  }
  _connect() {
      //var tempName = "Maha"+Math.random();
      var meetingIdElem = document.getElementById("meetingId") as HTMLInputElement
      var meetingId = meetingIdElem.value;
      this.topic = "/topic/meetings"+"/"+meetingId;
      //let ws = new SockJS(this.webSocketEndPoint+"?user="+tempName);
      let ws = new WebSocket(`${this.agoraConfigObject.webSocketEndPoint}`);
      this.stompClient = Stomp.over(ws);
      this.stompClient.debug = function (){};
      const _this = this;
      
      _this.stompClient.connect({"userId":localStorage.getItem("userId")}, function (frame:any) {
          _this.stompClient.subscribe(_this.topic, function (message:any) {
               var messResp = JSON.parse(message.body);
               if(localStorage.getItem("userId")!=messResp['sentBy']){
                    if(messResp.elementType!=undefined && messResp.elementType=="speechToText"){
                        _this.commonAgService.joinOrLeaveSpeechToText(messResp);
                    }else{
                        _this.commonAgService.setCollabData(messResp);
                    }
               }
          });
          //_this.stompClient.reconnect_delay = 2000;
      }, this.errorCallBack);
  };

  _disconnect() {
    if (this.stompClient != null && this.stompClient.connected==true) {
        this.stompClient.disconnect();
    }
}

  // on error, schedule a reconnection attempt
  errorCallBack(error:any) {
      setTimeout(() => {
          this._connect();
      }, 5000);
  }
  audioErrorCallBack(error:any){
    
  }

/**
 * Send message to sever via web socket
 * @param {*} message 
 */
  _send(message:any) {
      var meetingIdElem = document.getElementById("meetingId") as HTMLInputElement
      var meetingId = meetingIdElem.value;
      this.stompClient.send("/app/hello"+"/"+meetingId, {}, JSON.stringify(message));
  }

  onMessageReceived(message:any) {
      this.meetings.push(JSON.stringify(message.body));
      //this.appComponent.handleMessage(JSON.stringify(message.body));
  }

  _connectAudio() {
    
    var meetingIdElem = document.getElementById("meetingId") as HTMLInputElement
    //var meetingId = meetingIdElem.value;
    var meetingId=100;
    this.audiotopic = "/topic/recordAudio"+"/"+meetingId;
    let ws = new WebSocket(`${this.agoraConfigObject.webSocketEndPoint}`);
   // let ws = new WebSocket('ws://localhost:2023/audioSync');
    this.audioStompClient = Stomp.over(ws);
    this.audioStompClient.debug = function (){};
    const _this = this;
    _this.audioStompClient.connect({"userId":localStorage.getItem("userId")}, function (frame:any) {
    }, this.audioErrorCallBack);
};

_disconnectAudio() {
    if (this.audioStompClient != null && this.audioStompClient.connected==true) {
        this.audioStompClient.disconnect();
    }
  }
async  sendBinaryDataToWebSocket(blob:Blob,meetingId:any) {
    try {
        // Convert Blob to binary data (Uint8Array)
        var fileReader = new FileReader();
        fileReader.onload = ()=> {
            var base64String = fileReader.result as string;
            var newstring = base64String.split(',')[1];
            this.audioStompClient.send("/app/recordAudio"+"/"+meetingId, {},newstring);
        };
        fileReader.readAsDataURL(blob);
    } catch (error) {
        console.error('Error sending binary data to WebSocket:', error);
    }
}
async  sendSpeechAudioToWebSocket(blob:Blob,meetingId:any) {
    try {
        var participantId = localStorage.getItem("userId");
        var participantName = localStorage.getItem("userName")
        var fileReader = new FileReader();
        fileReader.onload = ()=> {
            var base64String = fileReader.result as string;
            var newstring = base64String.split(',')[1];
           
            this.audioStompClient.send("/app/audioTrans", {},JSON.stringify({
                meetingId:meetingId+"",
                participantId:participantId+"",
                participantName:participantName+"",
                audioData: newstring,
                timestamp: Date.now()+"",
                isSpeaking: "true"
              }));
        };
        fileReader.readAsDataURL(blob);
    } catch (error) {
        console.error('Error sending binary data to WebSocket:', error);
    }
}

}
